// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/modern/" + {"96":"detail-page","234":"index-page","247":"history-page","328":"focus-visible","353":"imask"}[chunkId] + "." + {"96":"9baa47f6","234":"8e3a693f","247":"0c505040","328":"3f33fca7","353":"45da0a7a"}[chunkId] + ".js";
};